module.exports = __webpack_public_path__ + "assets/img/fycc-title.29f65f2f.png";